import { SvgLine } from "../../../svg_container/js/svg_container";
// interfaces
import { ConnectedPeople, VideoItem } from "../posters";
import { AllDots, Point, getThemeColour } from "../../data/map_data";

enum dotState {
  DEFAULT = "default",
  RELATED = "related",
  UNRELATED = "unrelated",
}

const getPointFromId = (id: string, points: Point[]): Point => {
  let thisPoint: Point | undefined;
  thisPoint = points.find((point) => point.id === id);
  if (thisPoint === undefined) {
    new Error(`ERROR: no point data for point id ${id}`);
    return { id: "idError", x: 0, y: 0 };
  } else {
    return thisPoint;
  }
};

// get list of points on all lines in dotData
const getSVGLineData = (dotData: AllDots): SvgLine[] => {
  let svgLines: SvgLine[] = [];
  dotData.lines.map((line) => {
    let linePoints: Point[] = line.pointIds.map((pointId) =>
      getPointFromId(pointId, dotData.points)
    );
    svgLines.push({ points: linePoints });
  });
  return svgLines;
};

const getConnectedLineData = (
  dotData: AllDots,
  personId: string,
  connectedPerson: ConnectedPeople
) => {
  let points: Point[] = [];
  dotData.lines.forEach((line) => {
    if (
      line.pointIds.includes(personId) &&
      line.pointIds.includes(connectedPerson.id)
    ) {
      points = line.pointIds.map((pointId) =>
        getPointFromId(pointId, dotData.points)
      );
    }
  });
  const colour: string = getThemeColour(connectedPerson.theme);

  return { points, colour };
};

const getThemedConnections = (
  person: VideoItem,
  dotData: AllDots,
  selectedTheme: string
): SvgLine[] => {
  let svgLines: SvgLine[] = [];
  person.connectedPeople.forEach((connectedPerson: ConnectedPeople) => {
    if (selectedTheme === "all" || connectedPerson.theme === selectedTheme) {
      const { points, colour } = getConnectedLineData(
        dotData,
        person.id,
        connectedPerson
      );
      svgLines.push({ points, colour });
    }
  });
  return svgLines;
};

const getDotStyle = (
  person: VideoItem,
  selectedPerson: VideoItem,
  theme: string
): dotState => {
  if (person.id === selectedPerson.id) {
    return dotState.DEFAULT;
  } else {
    let isPersonRelated: boolean = false;
    // is person in list of connected people
    selectedPerson.connectedPeople.forEach((connectedPerson) => {
      if (connectedPerson.id === person.id) {
        // is connected person also related by selected theme
        if (theme === "all" || theme === connectedPerson.theme) {
          isPersonRelated = true;
        }
      }
    });
    return isPersonRelated ? dotState.RELATED : dotState.UNRELATED;
  }
};

const getViewBox = () => {
  const containerRect: DOMRect = document
    .getElementById("dotContainer")!
    .getBoundingClientRect();
  const margin: number = 8;
  return {
    left: margin - containerRect.left,
    right: window.innerWidth - margin - containerRect.left,
    top: margin - containerRect.top,
    bottom: window.innerHeight - margin - containerRect.top,
  };
};

// called from main
// this is messy as building data from 2 different data sources
const getThemeForLineId = (id: string, people: VideoItem[]) => {
  let matchedTheme = "";
  // loop through all people
  people.forEach((person: VideoItem) => {
    // and connected people to get matching lineId to find theme
    person.connectedPeople.forEach((connectedPerson) => {
      if (id === connectedPerson.lineId) matchedTheme = connectedPerson.theme;
    });
  });
  return matchedTheme;
};

export {
  getPointFromId,
  getSVGLineData,
  getThemedConnections,
  getThemeForLineId,
  getViewBox,
  getDotStyle,
};
